/**
 * @fileoverview Shared rule for the deliverable submission form, used by both
 * the drawer (fixed footer button) and the section (form fields) so they never
 * disagree. Single-deliverable contract (AR-741): when a done delivery exists
 * the service reuses its id, so the form stays available after a successful
 * submit — but as files-only editing on that SAME delivery (no re-submit).
 */

import type { DeliverableDetail } from '../types'

/** True when the student can submit (or resubmit) this deliverable. */
export const canSubmitDeliverable = (data: DeliverableDetail | null): boolean =>
  Boolean(data && data.projectId && data.studentTaskDeliveryId)
